'use client';
import type { NextPage } from 'next';
import { useState, FormEvent } from 'react';
import VoiceInput from '@/components/HeroBlock/components/VoiceInput/VoiceInput';
import ButtonSimple from '@/components/HeroBlock/components/ButtonSimple/ButtonSimple';
import styles from './jet-book1440px.module.scss';
import { ErrorType, JetBook1440pxType, TabType } from '@/types/TextForm.types';

const TextForm: NextPage<JetBook1440pxType> = ({
  className = '',
  title,
  text,
}) => {
  const [activeTab, setActiveTab] = useState<TabType>('one-way');
  const [fromLocation, setFromLocation] = useState('');
  const [toLocation, setToLocation] = useState('');
  const [errors, setErrors] = useState<ErrorType>({ from: '', to: '' });

  const validateForm = (): boolean => {
    const newErrors = { from: '', to: '' };
    let isValid = true;

    if (!fromLocation.trim()) {
      newErrors.from = 'Please enter departure location';
      isValid = false;
    }

    if (!toLocation.trim()) {
      newErrors.to = 'Please enter arrival location';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      console.log({
        activeTab,
        fromLocation,
        toLocation,
      });
    }
  };

  const handleFromChange = (value: string) => {
    setFromLocation(value);
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, from: '' }));
    }
  };

  const handleToChange = (value: string) => {
    setToLocation(value);
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, to: '' }));
    }
  };

  return (
    <section className={styles.textFormWrapper}>
      <div className="container">
        <div className={[styles.jetbook1440px, className].join(' ')}>
          <div className={styles.leftcol}>
            <h2
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
            <div className={styles.text}>
              <p
                className={styles.whetherYoureA}
                dangerouslySetInnerHTML={{ __html: text }}
              ></p>
            </div>
          </div>
          <section className={styles.form}>
            <h3 className={styles.title1}>Book your flight now</h3>
            <div className={styles.tabs}>
              <div
                className={
                  activeTab === 'one-way' ? styles.tabactive : styles.tabdefault
                }
                onClick={() => setActiveTab('one-way')}
              >
                <div className={styles.item}>One Way</div>
              </div>
              <div
                className={
                  activeTab === 'round-trip'
                    ? styles.tabactive
                    : styles.tabdefault
                }
                onClick={() => setActiveTab('round-trip')}
              >
                <div className={styles.item1}>Round Trip</div>
              </div>
              <div
                className={
                  activeTab === 'multi-city'
                    ? styles.tabactive
                    : styles.tabdefault
                }
                onClick={() => setActiveTab('multi-city')}
              >
                <div className={styles.item1}>Multi-City</div>
              </div>
              <div
                className={
                  activeTab === 'empty-leg'
                    ? styles.tabactive
                    : styles.tabdefault
                }
                onClick={() => setActiveTab('empty-leg')}
              >
                <div className={styles.item1}>Empty Leg</div>
              </div>
            </div>
            <form className={styles.comboboxParent} onSubmit={handleSubmit}>
              <div className={styles.inputWrapper}>
                <VoiceInput
                  label="Where from?"
                  value={fromLocation}
                  onChange={handleFromChange}
                />
                {errors.from && (
                  <div className={styles.errorMessage}>{errors.from}</div>
                )}
              </div>
              <div className={styles.inputWrapper}>
                <VoiceInput
                  label="Where to?"
                  value={toLocation}
                  onChange={handleToChange}
                />
                {errors.to && (
                  <div className={styles.errorMessage}>{errors.to}</div>
                )}
              </div>
              <ButtonSimple
                color="accent"
                highContrast
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text="Search"
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                designBlendingMode="/img/heroBlock/microphone.svg"
                designBlendingMode1="/img/heroBlock/microphone.svg"
              />
            </form>
          </section>
        </div>
      </div>
    </section>
  );
};

export default TextForm;
